<template>
  <el-dialog
    append-to-body
    width="900px"
    :title="info.desc"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table
      size="mini"
      :data="table.data"
      max-height="500px"
      v-loading="table.loading"
      style="width: 100%; margin-bottom: 10px"
      border
    >
      <el-table-column type="index" label="序号"> </el-table-column>
      <el-table-column prop="username" label="用户名" width="120" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="account" label="手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="50">
        <template slot-scope="{ row }">
          {{ ['',"女", "男"][row.sex] }}
        </template>
      </el-table-column>
      <el-table-column prop="school_name" label="大学名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="education" label="学历" width="60">
      </el-table-column>
      <el-table-column prop="major" label="专业" width="100" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="create_time" label="注册日期" width="180">
      </el-table-column>
      <el-table-column prop="is_vip" label="是否会员" width="100">
        <template slot-scope="{ row }">
          {{ ["非会员", "会员"][row.is_vip] }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination__wrap">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="table.params.page"
        :page-size="table.params.count"
        :total="table.total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      >
      </el-pagination>
    </div>
    <el-row type="flex" justify="center" style="margin-top: 6px">
      <el-button type="primary" @click="toggle(false)">关闭</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      visible: false,
      loading: false,
      info: {},
      table: {
        loading: false,
        params: {
          type: "",
          job_id: "",
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {},
  methods: {
    handleSizeChange(pageSize) {
      this.table.params.count = pageSize;
      this.table.params.page = 1;
      this.getTable();
    },
    //页面改变时触发
    handleCurrentChange(page) {
      this.table.params.page = page;
      this.getTable();
    },
    getDetail(row, title) {
      this.title = title;
      this.info = row;
      this.table.params.type = row.apiType;
      this.table.params.job_id = row.id;
      this.getTable();
    },
    getTable() {
      this.table.loading = true;
      let _params = { ...this.table.params };
      this.$http
        .get("/admin/job/log", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    reset(done) {
      this.table= {
        loading: false,
        params: {
          type: "",
          job_id: "",
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
<style scoped lang="scss">
.custom-desc {
  width: 100%;
}
</style>